import { render, staticRenderFns } from "./FooterNavbar.vue?vue&type=template&id=50739333&"
import script from "./FooterNavbar.vue?vue&type=script&lang=js&"
export * from "./FooterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports